/**
 * StatusPropagatedContent — renders `status_propagated` entries.
 *
 * EAINT-734 lineage, restored by EAINT-764 CR-9: which consumers a status change cascaded to, and
 * via which axis (`measure` = measures_into edge, `containment` = sphere containment).
 */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const StatusPropagatedContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as {
    previousStatus?: string | null;
    newStatus?: string;
    propagatedTo?: Array<{ sphereId: string; via: string }>;
  };
  const targets = payload.propagatedTo ?? [];

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t('timeline.eventContent.statusPropagated', {
          from: payload.previousStatus ?? '',
          to: payload.newStatus ?? '',
          count: targets.length,
        })}
      </span>
    </div>
  );
};

export default StatusPropagatedContent;
